export const styles = theme => ({
  button: {
    width: 110,
    height: 36,
    border: '1px solid',
    borderColor: 'var(--color-button-primary)',
    borderRadius: 4,
    color: 'var(--color-button-primary)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginRight: '12px',
    backgroundColor: theme.tabs.support.assignToButton,
    whiteSpace: 'nowrap',
    '&:disabled': {
      cursor: 'no-drop',
    },
  },
  popover: {
    width: 240,
    maxHeight: 180,
  },
  adminItem: {
    padding: '7px 12px',
    cursor: 'pointer',
    fontSize: 14,
    '&:hover': {
      background: 'var(--color-hover-overlay-primary)',
    },
  },
})
